import { MaintenanceNone } from '@atlassian/mpac-types';
/* Default values for each of the feature flags from `MarketplaceFeatureFlags`. */
export const DEFAULT_MARKETPLACE_FEATURE_FLAGS = {
  allowSectionMessageForPartnersForMigrationToCcp: [],
  enableFiftyKPricingTiers: false,
  maintenanceBannerConfiguration: MaintenanceNone,
  enablecapabilitysets: []
};